import 'reflect-metadata';
import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

Sentry.init({
  dsn: 'https://3cc517a3221eff509023ff58960a7419@o4510719926796288.ingest.us.sentry.io/4511184875487232',
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
});

// Configure PDF.js worker to load from local assets (copied during build from
// node_modules via the postinstall script). Two consumers:
//  - ng2-pdf-viewer checks window.pdfWorkerSrc before falling back to CDN.
//  - QcPdfViewerComponent reads pdfjsLib.GlobalWorkerOptions.workerSrc.
// Using document.baseURI respects Angular's <base href> for correct path resolution.
const PDF_WORKER_URL = new URL('assets/pdfjs/pdf.worker.min.mjs', document.baseURI).toString();
(window as any).pdfWorkerSrc = PDF_WORKER_URL;
// pdfjs-dist is only needed by qc-pdf-viewer when an operator opens the
// Parsed Data tab. Loading it here is purely to set the worker URL early.
// Catch failures so a broken pdfjs install can never block app bootstrap —
// the viewer will set the worker URL again on its own first render anyway.
import('pdfjs-dist')
    .then((pdfjsLib) => {
        pdfjsLib.GlobalWorkerOptions.workerSrc = PDF_WORKER_URL;
    })
    .catch((err) => console.warn('[main] pdfjs worker pre-config skipped:', err));

bootstrapApplication(AppComponent, appConfig).catch((err) => {
    // Bootstrap failure = blank app shell. Surface the error visibly so we
    // don't end up debugging white-screen tickets from server logs alone.
    console.error('[bootstrap] application failed to start:', err);
    try {
        const body = document.body;
        if (body) {
            body.innerHTML =
                '<div style="font-family:system-ui;padding:32px;color:#b42318;background:#fdecea;border:1px solid #f0b5b0;border-radius:8px;margin:32px;max-width:760px">' +
                '<h2 style="margin:0 0 8px">Application failed to start</h2>' +
                '<p style="margin:0 0 8px;color:#3a4a40">Open DevTools → Console for the full stack trace. ' +
                'Reload after fixing; this message is shown when the Angular bootstrap throws.</p>' +
                '<pre style="white-space:pre-wrap;font-size:12px;color:#14201a;margin:0">' +
                (err && (err.stack || err.message || String(err))) +
                '</pre></div>';
        }
    } catch { /* nothing more we can do */ }
});
